<app-detalhe-formulario #formulariobusca [hidden]="pedido || isLoading"></app-detalhe-formulario>

<div *ngIf="isLoading" style="height: 170px;"
  class="mt-4 d-flex flex-column justify-content-center align-items-center">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    <span class="mt-3">Aguarde... Carregando dados...</span>
</div>

<div class="container consulta-detalhe pb-4" [hidden]="!(pedido && !isLoading)">
  <ng-container>
    <div class="info-pedido mt-4 p-3">
      <button class="no-print"
        style="float: right;margin-top: -12px;"
        mat-raised-button (click)="novaConsulta()">
          Nova busca
      </button>
      <h3 class="uppercase">Informações sobre o pedido</h3>
      <hr>
      <div class="inner-info p-3">
        <div class="row">
          <app-icone-descricao
            [Icone]="'fas fa-user-tie'"
            [Titulo]="'Cliente:'"
            [Descricao]="pedido?.nome">
          </app-icone-descricao>
          <app-icone-descricao
            [Icone]="'fas fa-boxes'"
            [Titulo]="'Número do Lote:'"
            [Descricao]="pedido?.loteId">
          </app-icone-descricao>
          <app-icone-descricao
            [Icone]="'fas fa-clipboard-check'"
            [Titulo]="'NRT:'"
            [Descricao]="pedido?.pedidoId">
          </app-icone-descricao>
          <app-icone-descricao
            [Icone]="'fas fa-file-alt'"
            [Titulo]="'Número de documento:'"
            [Descricao]="pedido?.documento">
          </app-icone-descricao>
          <app-icone-descricao
            [Icone]="'fas fa-paper-plane'"
            [Titulo]="'Serviço:'"
            [Descricao]="pedido?.nomeServico">
          </app-icone-descricao>
          <app-icone-descricao
            [Icone]="'fas fa-calendar-alt'"
            [Titulo]="'Entregar até:'"
            [Descricao]="pedido?.dtEntregaPrevista">
          </app-icone-descricao>
        </div>
      </div>
    </div>

    <div class="detalhes mt-4 mb-4 " *ngIf="pedido">
      <app-bloco-detalhes [Pedido]="pedido" [TabIndex]="tabIndex"></app-bloco-detalhes>
    </div>
  </ng-container>
</div>
